import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Keep logs in console for debugging in WebView.
    console.error("Mini App render error:", error, errorInfo);
  }

  onReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <section className="errorFallback">
          <h2>Что-то пошло не так</h2>
          <p>Попробуйте перезапустить миниапп.</p>
          <button type="button" className="button button--accent" onClick={this.onReload}>
            Перезапустить
          </button>
        </section>
      );
    }
    return this.props.children;
  }
}

